
<div>
    <b-modal ref="modal-share-catalog" id="modal-share-catalog" size="md" centered hide-footer
             v-if="contactData != null">
        <div class="row">
            <div class="col-12 text-center">
                <h4>Ingresa el correo para enviar este catálogo</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <input v-on:keyup.enter="validateData()" v-model="userCredentials.email"
                       @blur="validateFormat('email', 'email')" type="email"
                       class="form-control text-center" placeholder="Correo Electrónico">
                <label class="validation" v-show="errors['email']">{{ errors['email'] }}</label>
            </div>
            <div class="col-12 col-md-12 text-center">
                <button :disabled="isLoading" @click="validateData()" class="btn btn-primary mt-4 w-50">
                    Enviar
                    <span v-if="isLoading" class="spinner-border text-light spinner-border-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </span>
                </button>
                <br>
            </div>
        </div>
    </b-modal>
</div>
